import { SUPPORTED_LOCALES } from './core.constants';

export const HIDE_ORG_ROUTES = {
  [SUPPORTED_LOCALES.ENGLISH]: {
    TRIP_DETAILS: '/get-a-quote/trip-details',
    SELECT_PLAN: '/get-a-quote/plan-selection',
    QUOTE_DETAILS: '/get-a-quote/quote-summary',
    CONTACT_DETAILS: '/apply',
    PAYMENT: '/apply/payment',
    CONFIRMATION: '/apply/confirmation'
  },
  [SUPPORTED_LOCALES.FRENCH]: {
    TRIP_DETAILS: '/obtenir-une-soumission/infos-voyage',
    SELECT_PLAN: '/obtenir-une-soumission/choisir-regime',
    QUOTE_DETAILS: '/obtenir-une-soumission/apercu-soumission',
    CONTACT_DETAILS: '/adherer',
    PAYMENT: '/adherer/paiement',
    CONFIRMATION: '/adherer/confirmation'
  }
};

export const COVERME_ROUTES = {
  [SUPPORTED_LOCALES.ENGLISH]: {
    TRAVELLER_DETAILS: '/get-a-quote',
    TRIP_DETAILS: '/get-a-quote/trip-details',
    SELECT_PLAN: '/get-a-quote/plan-selection',
    QUOTE_DETAILS: '/get-a-quote/quote-summary',
    CONTACT_DETAILS: '/apply',
    PAYMENT: '/apply/payment',
    CONFIRMATION: '/apply/confirmation',
    WELCOME: '/welcome',
    SSO: '/sso'
  },
  [SUPPORTED_LOCALES.FRENCH]: {
    TRAVELLER_DETAILS: '/obtenir-une-soumission',
    TRIP_DETAILS: '/obtenir-une-soumission/infos-voyage',
    SELECT_PLAN: '/obtenir-une-soumission/choisir-regime',
    QUOTE_DETAILS: '/obtenir-une-soumission/apercu-soumission',
    CONTACT_DETAILS: '/adherer',
    PAYMENT: '/adherer/paiement',
    CONFIRMATION: '/adherer/confirmation',
    WELCOME: '/welcome',
    SSO: '/sso'
  }
};

export const POLICY_ROUTES = {
  QUOTE: '',
  PLAN_SELECTION: '',
  PLAN_SELECTION_ADMIN: '/plan',
  TRAVELLER_DETAILS: '/travellers',
  SUMMARY: '/summary',
  CONFIRMATION: '/confirmation',
  BACK_TO_QUOTE: '/quote',
  BOOKING: '/booking'
};

export const MAINTENANCE_ROUTES = {
  [SUPPORTED_LOCALES.ENGLISH]: {
    ENDORSEMENT: 'endorsement/:policyNumber',
    ENDORSEMENT_VIEW: 'endorsement/:policyNumber/view',
    ENDORSEMENT_POLICIES: 'endorsement/:policyNumber/policies',
    ENDORSEMENT_EDIT: 'endorsement/:policyNumber/edit',
    ENDORSEMENT_DELIVERY: 'endorsement/:policyNumber/delivery',
    ENDORSEMENT_FINANCIALS: 'endorsement/:policyNumber/financials',
    ENDORSEMENT_NOTES: 'endorsement/:policyNumber/notes',
    SEARCH: ''
  },
  [SUPPORTED_LOCALES.FRENCH]: {
    ENDORSEMENT: 'endorsement/:policyNumber',
    ENDORSEMENT_VIEW: 'endorsement/:policyNumber/view',
    ENDORSEMENT_POLICIES: 'endorsement/:policyNumber/policies',
    ENDORSEMENT_EDIT: 'endorsement/:policyNumber/edit',
    ENDORSEMENT_DELIVERY: 'endorsement/:policyNumber/delivery',
    ENDORSEMENT_FINANCIALS: 'endorsement/:policyNumber/financials',
    ENDORSEMENT_NOTES: 'endorsement/:policyNumber/notes',
    SEARCH: ''
  }
};

export const AGENT_ROUTES = {
  [SUPPORTED_LOCALES.ENGLISH]: {
    WELCOME: '/welcome',
    CONTACTUS: '/contact-us',
    FAQS: '/faqs',
    RESOURCE: '/resource'
  },
  [SUPPORTED_LOCALES.FRENCH]: {
    WELCOME: '/welcome',
    CONTACTUS: '/contact-us',
    FAQS: '/faqs',
    RESOURCE: '/resource'
  }
};

export const ADVISORS_ROUTES = {
  [SUPPORTED_LOCALES.ENGLISH]: {
    WELCOME: '/welcome',
    CONTACTUS: '/contact-us',
    FAQS: '/faqs',
    RESOURCE: '/resource',
    FORBIDDEN_UNLICENSED: '/forbidden',
    SERVER_ERROR: '/error'
  },
  [SUPPORTED_LOCALES.FRENCH]: {
    WELCOME: '/welcome',
    CONTACTUS: '/contact-us',
    FAQS: '/faqs',
    RESOURCE: '/resource',
    FORBIDDEN_UNLICENSED: '/forbidden',
    SERVER_ERROR: '/error'
  }
};

export const USERS_ROUTES = {
  [SUPPORTED_LOCALES.ENGLISH]: {
    REGISTER: '/register',
    INFO: '/:agentId',
    LISTING: ''
  },
  [SUPPORTED_LOCALES.FRENCH]: {
    REGISTER: '/register',
    INFO: '/:agentId',
    LISTING: ''
  }
};

export const TRAVELLER_TYPE_KEY = {
  FAMILY: 'family',
  INDIVIDUAL: 'individual'
};

export const TRIP_TYPE_KEY = {
  SINGLE_TRIP: 'single',
  MULTI_TRIP: 'multi',
  ADD_ON: 'addon'
};

export enum DAYJS_DIFF {
  YEARS = 'y',
  DAYS = 'd',
  MONTHS = 'm',
  SECONDS = 's'
}

export const MQ_ACTION = {
  NEXT: new RegExp(/^(next)$/, 'i'),
  CATEGORY: new RegExp(/^(A\+|A|B|C)$/)
};

export enum QUOTE_FORM_CONSTANTS {
  ONE = 1,
  THREE = 3,
  TOGGLE_MAX_Y_WIDTH = 350
}

export const THIRTY = 30;
export const PHONE_NUMBER_LENGTH = 10;
export const POLICY_PER_PAGE = 10;

export enum PLAN_TYPE {
  VISITOR_TO_CANADA = 'VISITOR_TO_CANADA',
  STUDENT = 'STUDENT',
  MEDICAL = 'MEDICAL',
  TRIP_CANCELLATION = 'TRIP_CANCELLATION',
  INCLUSIVE = 'INCLUSIVE',
  MULTI_TRIP_MEDICAL = 'MULTI_TRIP_MEDICAL',
  MULTI_TRIP_INCLUSIVE = 'MULTI_TRIP_INCLUSIVE',
  TOP_UP = 'TOP_UP',
  MEDICAL_UNDERWRITING = 'MEDICAL_UNDERWRITING',
  MUPS = 'MUPS',
  DEFAULT = ''
}

export const DOB_MIN_DAYS = 31;

export const CONTACT_US_KEY = 'GENERAL_INQUIRY';
export const DATE_REQUEST_FIELDS = ['startDateFrom', 'startDateTo'];
export const DATETIME_REQUEST_FIELDS = ['applicationDateFrom', 'applicationDateTo'];
export const MAPPED_RANGE = {
  applicationDate: ['applicationDateFrom', 'applicationDateTo'],
  startDate: ['startDateFrom', 'startDateTo']
};
export const DATE_FIELDS = ['applicationDate', 'startDate'];
export const FIELD_OPTIONS_POLICY = [
  'firstName',
  'lastName',
  'email',
  'phone',
  'policyNumber',
  'bookingRef',
  'groupNumber',
  'planCode',
  'organizationCode',
  'applicationDate',
  'startDate'
];

export const FIELD_OPTIONS_QUOTE = ['firstName', 'lastName', 'email', 'phone', 'policyNumber'];

export enum TRANSACTION_VIEWS {
  PAYMENT = 'PAYMENT',
  PREMIUM = 'PREMIUM'
}

export enum BANNER_TYPES {
  RESOURCES = 'resourcesBanner',
  FORMS = 'formsBanner',
  QUICK_QUOTE = 'quickQuoteBanner',
  MAINTENANCE = 'maintenanceBanner',
  USERS = 'usersBanner',
  FAQ = 'faqBanner'
}
export const TALL_BANNERS = [BANNER_TYPES.FAQ, BANNER_TYPES.FORMS, BANNER_TYPES.RESOURCES];
export const DEFAULT_BANNER = BANNER_TYPES.QUICK_QUOTE;

export enum USER_INFO_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  IN_PROGRESS = 'IN_PROGRESS'
}

export const tripInfoStartDate = 'tripInformation.startDate';

export const PREMIUM_PROTECTION_PLANS = ['SAIPPP', 'SNMPPP'];
